var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.2375 2.5H9.7625C5.2125 2.5 2.5 5.2125 2.5 9.7625V20.225C2.5 24.7875 5.2125 27.5 9.7625 27.5H20.225C24.775 27.5 27.4875 24.7875 27.4875 20.2375V9.7625C27.5 5.2125 24.7875 2.5 20.2375 2.5Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3254 15.0002L19.2004 12.1252C19.5629 11.7627 19.5629 11.1627 19.2004 10.8002C18.8379 10.4377 18.2379 10.4377 17.8754 10.8002L15.0004 13.6752L12.1254 10.8002C11.7629 10.4377 11.1629 10.4377 10.8004 10.8002C10.4379 11.1627 10.4379 11.7627 10.8004 12.1252L13.6754 15.0002L10.8004 17.8752C10.4379 18.2377 10.4379 18.8377 10.8004 19.2002C10.9879 19.3877 11.2254 19.4752 11.4629 19.4752C11.7004 19.4752 11.9379 19.3877 12.1254 19.2002L15.0004 16.3252L17.8754 19.2002C18.0629 19.3877 18.3004 19.4752 18.5379 19.4752C18.7754 19.4752 19.0129 19.3877 19.2004 19.2002C19.5629 18.8377 19.5629 18.2377 19.2004 17.8752L16.3254 15.0002Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.644e6fd438f878344df00e560e00c183.svg";
export { ForwardRef as ReactComponent };